// 1. Patch Console Error (React explicitly logs this error)
const originalConsoleError = console.error;
console.error = function (...args) {
    if (typeof args[0] === 'string' && /ResizeObserver loop/.test(args[0])) {
        return;
    }
    originalConsoleError.apply(console, args);
};

// 2. Patch ResizeObserver Class
const OriginalResizeObserver = window.ResizeObserver;
if (OriginalResizeObserver) {
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
        constructor(callback) {
            super((entries, observer) => {
                // Wrap callback in requestAnimationFrame to avoid loop limit
                window.requestAnimationFrame(() => {
                    if (!Array.isArray(entries) || !entries.length) return;
                    callback(entries, observer);
                });
            });
        }
    };
}

// 3. Global Error Handlers (for the Overlay)
const handleError = (e) => {
    const msg = e.message || e.reason?.message || "";
    if (/ResizeObserver loop/.test(msg)) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return true;
    }
};

window.addEventListener('error', handleError);
window.addEventListener('unhandledrejection', handleError);

// Aggressive window.onerror
const originalOnError = window.onerror;
window.onerror = function (msg, url, lineNo, columnNo, error) {
    if (typeof msg === 'string' && /ResizeObserver loop/.test(msg)) {
        return true; // Return true to suppress
    }
    if (originalOnError) {
        return originalOnError(msg, url, lineNo, columnNo, error);
    }
    return false;
};
